export function formatDate(stringDate: string) {
  const date = new Date(stringDate);

  // Define options for the Intl.DateTimeFormat
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Rome",
    hour12: false,
  };

  // Format the date to the desired format in the Rome timezone
  const formatter = new Intl.DateTimeFormat("it-IT", options);
  const formattedDate = formatter.format(date);

  // Adjust the formatted date to the desired output format (DD/MM/YYYY HH:MM)
  const [day, month, year, hour, minute] = formattedDate.match(
    /\d+/g,
  ) as string[];

  return `${day}/${month}/${year} ${hour}:${minute}`;
}
